"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseSchema_1 = require("../baseSchema");
const baseTrySchema_1 = require("../baseSchema/baseTrySchema");
class TryTranslateSubtitlesSchema extends baseTrySchema_1.BaseTrySchema {
    constructor({ result, statusCode, failureDescription }) {
        super({
            result,
            statusCode,
            failureDescription,
            componentName: 'TRANSLATE_SUBTITLES_BUTTON',
            componentSource: 'TRANSLATE_SUBTITLES_BUTTON'
        });
        this.action = baseSchema_1.ActionsName.TRY_TRANSLATE_SUBTITLES;
    }
    getDataHubEventData() {
        return {
            ...super.prepare()
        };
    }
}
exports.default = TryTranslateSubtitlesSchema;
